import React, { PureComponent } from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { emptyError } from '../../../components/common/validation/validation-utils';
import { PALETTE } from '../../../constants';
import styles from './forgot-password.styles';
import Text from '../../../components/common/text';
import { FormGroup, TextInput, Message, Label } from '@dbk/ui-forms';
import commonStyle from '../../../screens/user/login/login.common.style';
import Button from '@dbk/ui-buttons';
import Modal from '@dbk/ui-modal';
import WizardSteps from '@dbk/ui-wizard-steps';
import ResetCodePage from '../reset-code';

class ForgotPassword extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      username: undefined,
      email: undefined,
      usernameEmpty: undefined,
      isUsernameNumber: undefined,
      emailEmpty: undefined,
      emailInvalidSyntax: undefined,
      emailErrorText: '',
      showCallRMPrompt: undefined,
      showResetCode: undefined,
    };

    this.saveUsername = this.saveUsername.bind(this);
    this.saveEmail = this.saveEmail.bind(this);
    this.getEmailErrorText = this.getEmailErrorText.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.getResetCode = this.getResetCode.bind(this);
    this.showCallRMPrompt = this.showCallRMPrompt.bind(this);
    this.hideCallRMPrompt = this.hideCallRMPrompt.bind(this);
    this.renderForgotPasswordPage = this.renderForgotPasswordPage.bind(this);
  }

  saveUsername(e) {
    const value = e.target.value;
    const newValue = value.replace(/^\s+|\s+$/g, '');
    this.setState({ username: newValue });
  }

  saveEmail(e) {
    const value = e.target.value;
    const newValue = value.replace(/^\s+|\s+$/g, '');
    this.setState({ email: newValue });
  }

  validateEmail(value) {
    const emailRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    this.setState({ email: value });
    const isValid = emailRegEx.test(value);
    return isValid;
  }

  validate() {
    const { username, email } = this.state;
    const isUsernameEmpty = emptyError(username, false);
    const isUsernameNumber = !isNaN(username);
    const isEmailEmpty = emptyError(email, false);
    let isEmailValid = false;
    if (!isEmailEmpty) {
      isEmailValid = this.validateEmail(email);
    }

    const emailError = this.getEmailErrorText(isEmailEmpty, isEmailValid);

    const valid = !isUsernameEmpty && !isEmailEmpty && isEmailValid && !emailError && !isUsernameNumber;

    this.setState({
      username,
      email,
      usernameEmpty: isUsernameEmpty,
      isUsernameNumber: isUsernameNumber,
      emailEmpty: isEmailEmpty,
      emailInvalidSyntax: !isEmailValid,
      emailErrorText: emailError,
    });

    return valid;
  }

  getEmailErrorText(isEmailEmpty, isEmailValid) {
    const { i18n: { messages } } = this.props;

    if (isEmailEmpty) {
      return messages['app.reset.forgotPassword.emailEmpty'];
    }

    if (!isEmailValid) {
      return messages['app.reset.forgotPassword.emailInvalid'];
    }

    return undefined;
  }

  getResetCode() {
    const { username, email } = this.state;
    const { resetcode: { requestResetCode } } = this.props;

    if (this.validate()) {
      requestResetCode(username, email);
    }
  }

  showCallRMPrompt() {
    this.setState({ showCallRMPrompt: true });
  }

  hideCallRMPrompt() {
    this.setState({ showCallRMPrompt: false });
  }

  hideModal = () => {
    this.setState(() => ({
      showCallRMPrompt: false,
    }));
  };

  renderForgotPasswordPage() {
    const {
      i18n: { messages },
      resetcode: { verifyingUsernameAndEmail },
      resetcode: { showResetCodePage, errorText },
    } = this.props;
    const {
      username,
      email,
      usernameEmpty,
      emailEmpty,
      emailInvalidSyntax,
      emailErrorText,
    } = this.state;
    const nativeStyle = commonStyle;

    const formGroupLastMargin = nativeStyle.formGroupLastMargin;

    return (
      <View style={StyleSheet.flatten(styles.content)}>
        <WizardSteps useEqualSpacing steps={[
          { label: messages['app.reset.breadcrumbs.requestCode'] },
          { label: messages['app.reset.breadcrumbs.enterCode'] },
          { label: messages['app.reset.breadcrumbs.resetNewPassword'] },
        ]}
          currentStepIndex={0}
        />
        <div className="margin-top-20">
          <Text className="pad-top-bottom-10">
            {messages['app.reset.forgotPassword.description']}
          </Text>
        </div>
        <View className="LoginForm">
          <FormGroup className="pad-top-20">
            <Label style={StyleSheet.flatten(nativeStyle.labelStyle)}>{messages['app.auth.username']}</Label>
            <View className='form__input-wrapper' style={StyleSheet.flatten(nativeStyle.inputWrapper)}>
              <TextInput
                style={StyleSheet.flatten(nativeStyle.input)}
                textID="input-username"
                name="username"
                value={username}
                placeholder={messages['app.reset.forgotPassword.username']}
                onChange={this.saveUsername}
                autoCorrect={false}
                zIndex={-1}
              />
            </View>
            {usernameEmpty && (
              <Message style={StyleSheet.flatten(nativeStyle.userError)} type="error">
                {messages['app.reset.forgotPassword.usernameError']}
              </Message>
            )}
          </FormGroup>
          <FormGroup style={StyleSheet.flatten(formGroupLastMargin)} className="pad-top-20">
            <Label style={StyleSheet.flatten(nativeStyle.labelStyle)}>{messages['app.contact.email']}</Label>
            <View className='form__input-wrapper'>
              <TextInput
                style={StyleSheet.flatten(nativeStyle.input)}
                textID="input-email"
                name="email"
                value={email}
                placeholder={messages['app.reset.forgotPassword.email']}
                onChange={this.saveEmail}
                autoCorrect={false}
                zIndex={-1}
                autoCapitalize='none'
                keyboardType="email-address"
              />
            </View>
            {(emailEmpty || emailInvalidSyntax) && (
              <Message type="error">
                {emailErrorText}
              </Message>
            )}
          </FormGroup>
        </View>

        <View style={StyleSheet.flatten(styles.inputFields)}>

          {verifyingUsernameAndEmail === false &&
            <View className="text-center margin-top-50">

              <Button fullWidth size='large' onPress={this.getResetCode}>
                {messages['app.reset.forgotPassword.sendResetCode']}
              </Button>



              <div className="pad-top-30">
                <span className="inline-link" onClick={this.showCallRMPrompt}>
                  {messages['app.reset.forgotPassword.forgotUsernameAndPassword']}
                </span>
              </div>
            </View>
          }
          {verifyingUsernameAndEmail === true &&
            <ActivityIndicator
              animating
              color={PALETTE.primaryText}
              size="large" className="pad-top-50"
            />
          }

        </View>
      </View>
    );
  }

  render() {
    const {
      fnCloseModal,
      i18n: { messages },
      resetcode: { showResetCodePage },
    } = this.props;
    const { showCallRMPrompt } = this.state;
    return (
      <div className="scene">
        {!showResetCodePage && this.renderForgotPasswordPage()}
        {showResetCodePage && <ResetCodePage fnCloseModal={fnCloseModal} />}
        {showCallRMPrompt &&
          <Modal

            visible={this.showCallRMPrompt}
            isActive={this.state.showCallRMPrompt}
            onClose={this.hideModal}
            header={
              <Text style={{ color: 'white', textAlign: 'center' }}>
                {messages['app.login.popover.username.title']}
              </Text>
            }
            content={
              <Text style={{ color: 'white', textAlign: 'center' }}>
                {messages['app.reset.forgotPassword.contactRM']}
              </Text>
            }
          />
        }
        <div id="copyrightDisclaimer" className="secondary-content text-center">
          {messages['app.common.copyrightDisclaimer']}
        </div>
      </div>
    );
  }
}


export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.replace' },
    auth: {
      onLogin: { $call: 'login' },
      onValidateDevice: { $call: 'validateDevice' },
    },
    i18n: {
      messages: true,
    },
    resetcode: {
      requestResetCode: { $call: 'requestResetCode' },
      showResetCodePage: true,
      verifyingUsernameAndEmail: true,
      errorText: true,
    },
  },
},
)(ForgotPassword);
